import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import { Badge } from '@prisjakt/ui/badge';
import { FontEmphasis } from '@prisjakt/ui/text';

import { MediumUp, MobileOnly } from 'src/ui/block';
import { usePriceRowContext } from '../../../price-row-context';

import {
  ShippingType,
  isStockStatusSupported,
  getShippingDays,
  getStandardizedDeliveryText,
  getStockStatusBadgeColor,
  getStockStatusIcon,
} from './utils';

import { ShippingCollection, StockStatus } from 'src/types';

import { Wrapper, CaptionText } from './styles';

interface IDeliveryTimeProps {
  shipping?: ShippingCollection | null;
  stockStatus?: StockStatus | null;
}

export const DeliveryTime: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IDeliveryTimeProps>
>> = props => {
  const { shipping, stockStatus } = props;

  const { t } = useContext(AppContext);

  const { forceMobileView, newOfferItemExperiment } = usePriceRowContext();

  const label =
    stockStatus === 'in_stock' || stockStatus === 'incoming'
      ? `${t('product', 'delivery-time.label')}: `
      : '';
  const shippingDays = getShippingDays(t, ShippingType.CHEAPEST, shipping);
  const standardizedDeliveryText = getStandardizedDeliveryText(t, stockStatus);
  const deliveryTimeShort = isStockStatusSupported(stockStatus) && shippingDays;
  const deliveryTimeLong =
    label + (deliveryTimeShort ? shippingDays : standardizedDeliveryText);

  if (!shippingDays && !standardizedDeliveryText) {
    return null;
  }

  return (
    <Wrapper>
      {deliveryTimeShort && !newOfferItemExperiment && (
        <MobileOnly>
          <CaptionText emphasis={FontEmphasis.MEDIUM}>
            <span>{deliveryTimeShort}</span>
          </CaptionText>
        </MobileOnly>
      )}
      {newOfferItemExperiment && (
        <MobileOnly>
          <CaptionText emphasis={FontEmphasis.MEDIUM}>
            <Badge
              color={getStockStatusBadgeColor(stockStatus)}
              icon={getStockStatusIcon(stockStatus)}
              text={shippingDays || standardizedDeliveryText}
            />
          </CaptionText>
        </MobileOnly>
      )}
      {!forceMobileView && deliveryTimeLong && (
        <MediumUp>
          <CaptionText emphasis={FontEmphasis.MEDIUM}>
            <span>{deliveryTimeLong}</span>
          </CaptionText>
        </MediumUp>
      )}
    </Wrapper>
  );
};
